import { InjectionToken } from '@angular/core';
import { IConfig } from './config.service';

export const APP_CONFIG = new InjectionToken<IConfig>('app-config');
export const CONFIG_URL = './assets/config.json';
export const DSB_DIALOG_DATA = new InjectionToken<any>('dialog-data');
